var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height}},[_c('use',{class:_vm.innerClass,attrs:{"xlink:href":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }